import { defineStore } from 'pinia';
import request from '@/utils/request';
import Cookies from 'js-cookie';
import { ElMessage } from 'element-plus';

export const useCategoryStore = defineStore('category', {
    state: () => ({
        categoryList: [],
    }),

    getters: {
        getCategoryList: state => state.categoryList,
    },

    actions: {
        async fetchCategoryList() {
            const res: any = await request({
                url: '/api/categories',
                method: 'get',
            });
            if (res.code === 200) {
                this.categoryList = res.data.result;
            } else {
                ElMessage.error(res.message);
            }
        },
    },
    persist: true,
});
